import { Menu, Dropdown, /* Checkbox, Button, */ Modal } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import { useEffect } from 'react';
import { getAlbumList, getSelectParamsList } from '@/api/hdd/album';
import './selectAlbumModal.scss';

export default function SelectAlbumModal(props) {
    const schemeId =
        new URLSearchParams(window.location.search).get('schemeId') || 881;

    const [albumList, setAlbumList] = useState([]);
    const [resolution, setResolution] = useState([]);
    const [space, setSpace] = useState([]);
    const [resolutionItem, setResolutionItem] = useState({
        id: 'all',
        name: '全部分辨率',
    });
    const [spaceItem, setSpaceItem] = useState({ id: 'all', name: '全部空间' });

    const getSelectParams = () => {
        let params = { hDocId: schemeId, renderType: 0 };

        getSelectParamsList(params).then(res => {
            console.log(res, 'getSelectParamsList');
            let resolutionList = res.data.list.resolution?.map(v => ({
                id: v.resolution,
                name: v.resolution,
            }));
            let spaceList = res.data.list.roomType?.map(v => ({
                id: v.roomType,
                name: v.roomType,
            }));
            resolutionList.unshift({ id: 'all', name: '全部分辨率' });
            spaceList.unshift({ id: 'all', name: '全部空间' });
            setResolution(resolutionList);
            setSpace(spaceList);
        });
    };

    const getList = () => {
        getAlbumList({
            hDocId: schemeId,
            renderType: 0,
            status: 2,
            resolution:
                resolutionItem.id !== 'all' ? resolutionItem.id : undefined,
            roomType: spaceItem.id !== 'all' ? spaceItem.id : undefined,
        }).then(res => {
            let list = res.data.list;
            list.map(v => (v.checked = false));
            setAlbumList(list);
        });
    };

    useEffect(() => {
        console.log('SelectAlbumModal props:', props);
        if (!props.visible) return;

        getList();
        getSelectParams();
    }, [props.visible]);

    useEffect(() => {
        getList();
    }, [resolutionItem, spaceItem]);

    const onResolutionClick = ({ item, key }) => {
        console.log('resolution111', resolution);
        console.log('key', key);
        const selected = resolution.find(item => item.id === key);
        console.log('selected', selected);
        setResolutionItem(selected);
    };
    const onSpaceClick = ({ item, key }) => {
        const selected = space.find(item => item.id === key);
        console.log('selected', selected);

        setSpaceItem(selected);
    };

    const resolutionMenu = (
        <Menu
            onClick={onResolutionClick}
            defaultSelectedKeys={'0'}
            selectedKeys={resolutionItem?.id}>
            {resolution.map(item => (
                <Menu.Item key={item.id}>{item.name}</Menu.Item>
            ))}
        </Menu>
    );

    const spaceMenu = (
        <Menu onClick={onSpaceClick} selectedKeys={spaceItem?.id}>
            {space.map(item => (
                <Menu.Item key={item.id}>{item.name}</Menu.Item>
            ))}
        </Menu>
    );

    const [active, setActive] = useState();

    return (
        <Modal
            title="选择渲染图"
            visible={props.visible}
            onOk={() => props.handleOk(active)}
            centered
            width={870}
            className="select-album-modal"
            onCancel={() => props.setVisible(false)}>
            <div className="select-wrap">
                <Dropdown
                    overlay={resolutionMenu}
                    overlayClassName="hdd-dropdown-menu"
                    trigger={['click']}>
                    <span className="resolution">
                        {resolutionItem?.name}
                        <DownOutlined />
                    </span>
                </Dropdown>
                <Dropdown
                    overlay={spaceMenu}
                    overlayClassName="hdd-dropdown-menu"
                    trigger={['click']}>
                    <span className="space">
                        {spaceItem?.name}
                        <DownOutlined />
                    </span>
                </Dropdown>
            </div>
            <div className="select-album-wrap">
                {albumList.map((v, index) => {
                    return (
                        <div
                            key={index}
                            className={`select-album ${
                                active?.id === v.id ? 'active' : ''
                            }`}
                            onClick={() => setActive(v)}>
                            <div className="img-box">
                                <img src={v.coverImageUrl} alt="" />
                            </div>
                            <div className="select-album-name">{v.title}</div>
                        </div>
                    );
                })}
            </div>
        </Modal>
    );
}
